<template>
  <AppInput
    v-bind="$attrs"
    v-model="value"
    :theme="theme"
    :error="hideError ? '' : error"
    :custom-class="customClass"
    :error-position="errorPosition"
    :enter-key-enabled="enterKeyEnabled"
    :enterkeyhint="enterkeyhint"
    v-on="$listeners"
    @input="handleInput"
    @keydown.enter="focusNext(enterKeyEnabled, isMortgage, deviceType)"
  >
    <template
      v-if="$slots.countryBox"
      #countryBox
    >
      <div class="country-box">
        <img
          :src="require('@/assets/img/canadian-flag.png')"
          alt="Canadian Flag"
        >
        <span>+1</span>
      </div>
    </template>
  </AppInput>
</template>

<script>
import AppInput from '@/components/common/inputs/AppInput'
import navigation from '@/mixins/navigation'
import enterKeyFunctionality from '@/mixins/enter-key-functionality'

export default {
  // Name
  name: 'AppInputWithValidation',

  // Components
  components: {
    AppInput
  },

  mixins: [
    navigation,
    enterKeyFunctionality
  ],

  // Inherit Attrs
  inheritAttrs: false,

  // Props
  props: {
    fieldName: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'aggressive'
    },
    rules: {
      type: String,
      default: ''
    },
    hideError: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'green'
    },
    error: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    errorPosition: {
      type: String,
      default: 'bottom' // 'top' or 'bottom'
    },
    enterKeyEnabled: {
      type: Boolean,
      default: true
    },
    enterkeyhint: {
      type: String,
      default: 'go'
    }
  },

  data () {
    return {
      value: '',
      deviceType: ''
    }
  },

  computed: {
    isMobile () {
      return this.$store.state.tracking.device_type === 'm'
    },
    isMortgage () {
      return this.$store.getters['loans/isMortgage']
    }
  },

  mounted () {
    this.deviceType = this.isMobileOrTablet()
  },

  methods: {
    handleInput () {
      if (this.rules.includes('numeric')) {
        // Remove non-numeric characters
        this.value = this.value.replace(/[^0-9]/g, '')
      }
      if (!this.hideError) this.$_navigation_validateStep()
    },

    isMobileOrTablet () {
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 1
      const isSmallScreen = Math.min(window.innerWidth, window.innerHeight) <= 1024

      return hasTouch && isSmallScreen ? 'm' : 'd'
    }
  }
}
</script>

<style scoped lang="scss">
</style>
